export const ADD_PM = 'Add Project Manager'
export const ADDING_PM = 'Adding Project Manager...'

export const FIRST_NAME = 'First Name'
export const LAST_NAME = 'Last Name'
export const EMAIL = 'Email'
